(() => {
  const section = document.querySelector('[data-drbo-consent]');
  if (!section || section.dataset.consentInitialized) return;
  section.dataset.consentInitialized = 'true';
  const buttons = Array.from(section.querySelectorAll('[data-cookie-choice]'));
  const status = section.querySelector('[data-consent-status]');
  const purposes = ['analytics', 'marketing', 'preferences', 'sale_of_data'];
  let saving = false;
  let pendingPrivacy = null;

  function show() {
    section.hidden = false;
    section.classList.remove('is-hidden');
  }

  function showError() {
    show();
    status.hidden = false;
  }

  function getPrivacy() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return privacy && typeof privacy.setTrackingConsent === 'function' &&
      typeof privacy.currentVisitorConsent === 'function' ? privacy : null;
  }

  function ensurePrivacy() {
    if (getPrivacy()) return Promise.resolve(getPrivacy());
    if (pendingPrivacy) return pendingPrivacy;
    pendingPrivacy = new Promise((resolve, reject) => {
      let loadRequested = false;
      let settled = false;
      const timeout = setTimeout(() => finish(new Error('privacy-api-timeout')), 8000);
      const interval = setInterval(check, 100);
      function finish(error, privacy) {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        clearInterval(interval);
        if (error) reject(error);
        else resolve(privacy);
      }
      function check() {
        if (getPrivacy()) return finish(null, getPrivacy());
        if (loadRequested || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
        loadRequested = true;
        try {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
            if (error) finish(error);
            else if (getPrivacy()) finish(null, getPrivacy());
          });
        } catch (error) {
          finish(error);
        }
      }
      check();
    }).finally(() => { pendingPrivacy = null; });
    return pendingPrivacy;
  }

  function saveConsent(privacy, accepted) {
    const consent = Object.fromEntries(purposes.map(purpose => [purpose, accepted]));
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => reject(new Error('consent-save-timeout')), 8000);
      try {
        privacy.setTrackingConsent(consent, result => {
          clearTimeout(timeout);
          try {
            if (result && result.error) throw new Error('consent-save-failed');
            const current = privacy.currentVisitorConsent();
            if (!purposes.every(purpose => current[purpose] === (accepted ? 'yes' : 'no'))) {
              throw new Error('consent-not-confirmed');
            }
            resolve();
          } catch (error) {
            reject(error);
          }
        });
      } catch (error) {
        clearTimeout(timeout);
        reject(error);
      }
    });
  }

  section.addEventListener('click', async event => {
    const button = event.target.closest('[data-cookie-choice]');
    if (!button || !section.contains(button)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (saving) return;
    saving = true;
    status.hidden = true;
    section.setAttribute('aria-busy', 'true');
    buttons.forEach(control => { control.disabled = true; });
    try {
      const privacy = await ensurePrivacy();
      await saveConsent(privacy, button.dataset.cookieChoice === 'accepted');
      const configuredDays = Number(section.dataset.cookieTime);
      const days = Number.isFinite(configuredDays) && configuredDays > 0 ? configuredDays : 30;
      try {
        document.cookie = 'cookie_bar=' + button.dataset.cookieChoice + '; path=/; max-age=' + days * 86400 + '; SameSite=Lax; Secure';
      } catch (error) {}
      section.hidden = true;
      section.classList.add('is-hidden');
    } catch (error) {
      showError();
    } finally {
      saving = false;
      section.removeAttribute('aria-busy');
      buttons.forEach(control => { control.disabled = false; });
    }
  }, true);

  ensurePrivacy().then(privacy => {
    if (saving) return;
    const current = privacy.currentVisitorConsent();
    const hasDecision = purposes.every(purpose => current[purpose] === 'yes' || current[purpose] === 'no');
    if (hasDecision) {
      section.hidden = true;
      section.classList.add('is-hidden');
    } else {
      show();
    }
  }).catch(() => { if (!saving) showError(); });
})();


// DRBO consent reopen control — added 2026-10-01. Remove this block to roll back.
(() => {
  const banner = document.querySelector('[data-drbo-consent]');
  const privacyLink = document.querySelector('footer a[href="/policies/privacy-policy"]');
  const existingItem = privacyLink && privacyLink.closest('li');
  if (!banner || !existingItem || document.querySelector('[data-drbo-consent-reopen]')) return;
  const item = document.createElement('li');
  item.className = existingItem.className;
  const button = document.createElement('button');
  button.type = 'button';
  button.className = privacyLink.className;
  button.textContent = 'Cookie-Einstellungen';
  button.setAttribute('data-drbo-consent-reopen', '');
  button.style.cssText = 'background:none;border:0;padding:0;font:inherit;cursor:pointer;text-align:left;';
  button.style.color = window.getComputedStyle(privacyLink).color;
  button.addEventListener('click', () => {
    banner.hidden = false;
    banner.classList.remove('is-hidden');
    const status = banner.querySelector('[data-consent-status]');
    if (status) status.hidden = true;
    const reject = banner.querySelector('[data-cookie-choice="rejected"]');
    if (reject) reject.focus();
  });
  item.appendChild(button);
  existingItem.insertAdjacentElement('afterend', item);
})();
// End DRBO consent reopen control.
